import http from 'utils/http';
import { getInteractionContactUrl, getInteractionNoteUrl, getInteractionNotesUrl } from './apiUrls';
import { ContactRequest, ContactResponse, NoteRequest, NotesResponse } from './types';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';

export function getContact(interactionId: number, id: number, params?: object): Promise<ContactResponse> {
  return http.get(getInteractionContactUrl(interactionId, id), params);
}

export function updateContact(
  interactionId: number,
  id: number,
  payload: ContactRequest
): Promise<{ meta: { message: string } }> {
  return http.patch(getInteractionContactUrl(interactionId, id), payload);
}

export function getNotes(
  interactionId: number,
  id: number,
  params?: object
): Promise<{ data: NotesResponse[]; meta: MetaApiResponse }> {
  return http.get(getInteractionNotesUrl(interactionId, id), params);
}

export function createNote(interactionId: number, id: number, payload?: NoteRequest): Promise<NotesResponse> {
  return http.post(getInteractionNotesUrl(interactionId, id), payload);
}

export function updateNote(
  interactionId: number,
  contactId: number,
  id: number,
  payload?: NoteRequest
): Promise<NotesResponse> {
  return http.put(getInteractionNoteUrl(interactionId, contactId, id), payload);
}

export function deleteNote(
  interactionId: number,
  contactId: number,
  id: number,
  payload?: NoteRequest
): Promise<NotesResponse> {
  return http.delete(getInteractionNoteUrl(interactionId, contactId, id), payload);
}
